import React, { Component } from "react"
import Layout from "../components/layout-partnership";
import "../css/sharan-style.css";
import "../css/style.css";
import "../css/animate.min.css";
import "../css/responsive.css";
import "../css/bootstrap.min.css";
import "../css/swiper-bundle.min.css";
import Swiper, { Navigation, Pagination, Scrollbar, Autoplay, Thumbs, Mousewheel, Parallax } from 'swiper'

Swiper.use([Navigation, Pagination, Autoplay, Scrollbar, Thumbs, Mousewheel, Parallax]);


class PartnerUniversities extends Component {

  componentDidMount() {
    var swiper = new Swiper('.partner-swiper', {
      slidesPerView: 6,
      spaceBetween: 40,
      autoplay: true,
      // direction: 'vertical',
      speed: 300,
      loop: true,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      breakpoints: {
        // when window width is >= 320px
        320: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        480: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
        768: {
          slidesPerView: 4,
          spaceBetween: 20,
        },
        // when window width is >= 480px
        992: {
          slidesPerView: 5,
          spaceBetween: 20,
        },
        // when window width is >= 640px
        1200: {
          slidesPerView: 6,
          spaceBetween: 30,
        }
      }
    });

    var swiper = new Swiper('.blogs-swiper', {
      slidesPerView: 2,
      spaceBetween: 5,
      autoplay: true,
      // direction: 'vertical',
      speed: 300,
      loop: true,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
        // when window width is >= 320px
        320: {
          slidesPerView: 1,
          spaceBetween: 20,
        },
        480: {
          slidesPerView: 1,
          spaceBetween: 20,
        },
        768: {
          slidesPerView: 1,
          spaceBetween: 20,
        },
        // when window width is >= 480px
        992: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
        // when window width is >= 640px
        1200: {
          slidesPerView: 3,
          spaceBetween: 30,
        }
      }
    });
  }
  render() {
    return (
      <Layout >
        <section className="partner-sec partner-custom-styling">
          <div className="container">
            <div className="row">
              <div className="col-md-12 mt-3">
                <div className="partner-inner">
                  <div className="swiper-container partner-swiper">
                    <div className="swiper-wrapper d-flex align-items-center">
                      {/* <div className="swiper-slide logo-position1"><a href="#"><img src="https://media.publit.io/file/TheWorldgrad/UniversityLogosCommon/NYIT_logo_160x83_k0bi0f.png" alt="" /></a></div> */}
                      <div className="swiper-slide logo-position1">
                        <a href="#"><img src="https://media.publit.io/file/TheWorldgrad/UniversityLogosCommon/2.png" alt="" /></a>
                      </div>
                      <div className="swiper-slide logo-position1">
                        <a href="#"><img src="https://media.publit.io/file/TheWorldgrad/UniversityLogosCommon/3.png" alt="" /></a>
                      </div>
                      <div className="swiper-slide logo-position1">
                        <a href="#"><img src="https://media.publit.io/file/TheWorldgrad/UniversityLogosCommon/6.png" alt="" /></a>
                      </div>
                      <div className="swiper-slide logo-position1">
                        <a href="#"><img src="https://media.publit.io/file/TheWorldgrad/UniversityLogosCommon/10.png" alt="" /></a>
                      </div>
                      <div className="swiper-slide logo-position1">
                        <a href="#"><img src="https://media.publit.io/file/TheWorldgrad/UniversityLogosCommon/12.png" alt="" /></a>
                      </div>
                      <div className="swiper-slide logo-position1">
                        <a href="#"><img src="https://media.publit.io/file/TheWorldgrad/UniversityLogosCommon/4.png" alt="" /></a>
                      </div>
                      <div className="swiper-slide logo-position3">
                        <a href="#"><img src="https://media.publit.io/file/TheWorldgrad/UniversityLogosCommon/5.png" alt="" /></a>
                      </div>
                      <div className="swiper-slide logo-position5">
                        <a href="#"><img src="https://media.publit.io/file/TheWorldgrad/UniversityLogosCommon/13.png" alt="" /></a>
                      </div>
                      <div className="swiper-slide logo-position6">
                        <a href="#"><img src="https://media.publit.io/file/TheWorldgrad/UniversityLogosCommon/14.png" alt="" /></a>
                      </div>
                      <div className="swiper-slide logo-position7">
                        <a href="#"><img src="https://media.publit.io/file/TheWorldgrad/UniversityLogosCommon/16.png" alt="" /></a>
                      </div>
                      <div className="swiper-slide logo-position8">
                        <a href="#"><img src="https://media.publit.io/file/TheWorldgrad/UniversityLogosCommon/9.png" alt="" /></a>
                      </div>
                      <div className="swiper-slide logo-position9">
                        <a href="#"><img src="https://media.publit.io/file/TheWorldgrad/UniversityLogosCommon/11.png" alt="" /></a>
                      </div>
                      <div className="swiper-slide logo-position9">
                        <a href="#"><img src="https://media.publit.io/file/TheWorldgrad/UniversityLogosCommon/Final_Murdoch_mjnnf4.jpg" alt="" /></a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </Layout>
    )
  }
}
export default PartnerUniversities;
